import {MIN_DESKTOP} from "../constants";

export default () => ({
    fixed: false,
    state: false,
    isMobile: false,
    scrollPosition: 0,
    trigger() {
        this.state = !this.state;
    },
    onClickLogoOnHomePage() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    },
    onScroll() {
        this.fixed = window.scrollY > 0;
        this.scrollPosition = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
    },
    onResize() {
        if (this.state) {
            this.$store.body.fixed = window.innerWidth < MIN_DESKTOP;
        }
    },
    init() {
        addEventListener('scroll', this.onScroll.bind(this));
        this.$watch('state', (value) => {
            if (value) {
                this.$store.body.fixed = true;
            } else {
                this.$store.body.fixed = false;
            }
        });
        addEventListener('resize', this.onResize.bind(this));
        this.onScroll();
    }
})